import {
    faCheckCircle,
    faSortDown,
    faSortUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
    Dropdown,
    OverlayTrigger,
    Tooltip,
} from 'react-bootstrap';
import shortid from 'shortid';
import ChartMenuCustomToggle from '../ChartMenuCustomToggle';
import MoveQuestionToSection from '../../MoveQuestionToSection';
const ChartAccordionToggle = ({
    displayIdentifier,
    prompt,
    onToggleAccordion,
    handleExport,
    handleAddToReport,
    handleChangeChart,
    handleBenchmarkChange,
    handleShareALink,
    currentJob,
    currentChartType,
    currentBenchmark,
    visualization,
    anySegmentApplies,
    eventKey,
    isEditing,
}) => {
    return (
        <div className="cursor-pointer d-flex justify-content-between align-items-center mx-4 py-2 gap-3">
            <h3 className="d-flex justify-content-between align-items-center gap-6 flex-grow-1" onClick={onToggleAccordion}>
                <span className="code-block">{displayIdentifier}</span>
                <span className='flex-grow-1'>{prompt}</span>
            </h3>
            <div className='d-flex align-items-center'>
                <FontAwesomeIcon
                    onClick={onToggleAccordion}
                    size="lg"
                    icon={eventKey ? faSortUp : faSortDown}
                    style={{ height: eventKey ? '52px' : '38px' }}
                />
                {!isEditing && eventKey && (
                    <Dropdown style={{ height: Boolean(eventKey) ? '52px' : '38px' }}>
                        <Dropdown.Toggle className="w-100 d-flex" as={ChartMenuCustomToggle} />
                        <Dropdown.Menu size="sm" title="">
                            {!currentJob.queryResult.suppressed && <Dropdown.Item onClick={handleExport}> Export Question</Dropdown.Item>}
                            {!currentJob.queryResult.suppressed && <Dropdown.Item onClick={handleAddToReport}>Add to Report</Dropdown.Item>}
                            <Dropdown>
                                {(currentJob?.visualizationTypes?.length < 1 || visualization.details.segments.length > 0) && <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip>
                                            Other charts not available when a segment is applied
                                        </Tooltip>
                                    }
                                    delay={100}
                                >
                                    <Dropdown.Toggle
                                        disabled={currentJob?.visualizationTypes?.length < 1 || visualization.details.segments.length > 0}
                                        variant="secondary"
                                        className="w-100 d-flex bg-white text-dark border-0 px-4"
                                    >
                                        Change Chart
                                    </Dropdown.Toggle>
                                </OverlayTrigger>
                                }
                                {!(currentJob?.visualizationTypes?.length < 1 || visualization.details.segments.length > 0) && <Dropdown.Toggle
                                    variant="secondary"
                                    className="w-100 d-flex bg-white text-dark border-0 px-4"
                                >
                                    Change Chart
                                </Dropdown.Toggle>
                                }
                                <Dropdown.Menu size="sm" title="">
                                    {currentJob?.visualizationTypes?.map((chartOptions) => (
                                        <Dropdown.Item
                                            key={shortid.generate()}
                                            onClick={(e) => handleChangeChart(e, chartOptions)}
                                        >
                                            {chartOptions}
                                            {currentChartType === chartOptions && (
                                                <FontAwesomeIcon className="ml-2" icon={faCheckCircle} />
                                            )}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                            {!anySegmentApplies &&
                                (visualization?.details?.filter.constraintGroups?.length || 0) > 0 && (
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant="secondary"
                                            className="w-100 d-flex bg-white text-dark border-0 px-4"
                                        >
                                            Benchmark
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu size="sm" title="">
                                            <Dropdown.Item
                                                onClick={(e) =>
                                                    handleBenchmarkChange(e, {
                                                        national: !(currentBenchmark.national || false),
                                                        state: currentBenchmark.state || false,
                                                    })
                                                }
                                            >
                                                All Respondents{' '}
                                                {currentBenchmark.national && (
                                                    <FontAwesomeIcon className="ml-2" icon={faCheckCircle} />
                                                )}
                                            </Dropdown.Item>
                                            {(visualization?.details?.filter.constraintGroups?.filter(
                                                (f) => f.type === 'LOCATION'
                                            ).length || 0) > 0 &&
                                                (visualization?.details?.filter.constraintGroups?.filter(
                                                    (f) => f.type === 'QUESTION' || f.type === 'GENERAL'
                                                ).length || 0) > 0 && (
                                                    <Dropdown.Item
                                                        onClick={(e) =>
                                                            handleBenchmarkChange(e, {
                                                                national: currentBenchmark.national || false,
                                                                state: !(currentBenchmark.state || false),
                                                            })
                                                        }
                                                    >
                                                        Location{' '}
                                                        {currentBenchmark.state && (
                                                            <FontAwesomeIcon className="ml-2" icon={faCheckCircle} />
                                                        )}
                                                    </Dropdown.Item>
                                                )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                )}
                            <Dropdown.Item onClick={handleShareALink}>Share a link</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                )}

                {isEditing && (
                    <Dropdown style={{ height: eventKey ? '52px' : '38px' }}>
                        <Dropdown.Toggle className="w-100 d-flex" as={ChartMenuCustomToggle} />
                        <Dropdown.Menu size="sm" title="">
                            <MoveQuestionToSection questionId={currentJob.id} identifier={currentJob.code} />
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </div>
        </div>
    );
};

export default ChartAccordionToggle;